import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFFunnel = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 640 640",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M64 160C64 142.3 78.3 128 96 128L544 128C561.7 128 576 142.3 576 160C576 177.7 561.7 192 544 192L96 192C78.3 192 64 177.7 64 160zM160 320C160 302.3 174.3 288 192 288L448 288C465.7 288 480 302.3 480 320C480 337.7 465.7 352 448 352L192 352C174.3 352 160 337.7 160 320zM384 480C384 497.7 369.7 512 352 512L288 512C270.3 512 256 497.7 256 480C256 462.3 270.3 448 288 448L352 448C369.7 448 384 462.3 384 480z" })
});
export default SvgFFunnel;
